export default __webpack_public_path__ + "static/media/download-metamask.49b84c3b.png";